import React, { useEffect, useState } from "react";
import axios from "axios";
import { dashboardURL } from "../../Config/Url";
import { useTranslation } from "react-i18next";
import Card from "react-bootstrap/Card";
import { format } from "date-fns";
import SpinnerLoading from "../Common/SpinnerLoading";

const LastActivatedUser = () => {
  const { t: translator } = useTranslation();

  const [lastActivatedUser, setLastActivatedUser] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  let config = {
    headers: {
      "X-IsMockup": false,
    },
  };

  useEffect(() => {
    axios
      .get(`${dashboardURL}/last-activated-user`, config)
      .then((result) => {
        setLastActivatedUser({
          realName: result.data.realName,
          tenants: result.data.tenants,
          activationDate: format(
            new Date(result.data.activationDate),
            "dd. MM. yyyy."
          ),
        });
        setIsLoading(false);
      })
      .catch((err) => console.log(err.response));
  }, []);

  return (
    <>
      {isLoading && (
        <div className="dashboard-card-spinner">
          <SpinnerLoading />
        </div>
      )}

      {!isLoading && (
        <>
          <Card.Body className="dashboard-card-body-user">
            <div className="dashboard-card-body-user-part1">
              <span
                className="icon icon-user-account"
                style={{ fontSize: 85 }}
              ></span>
              <div className="dashboard-card-body-user-complexData">
                <span className="dashboard-card-body-user-data-name">
                  {lastActivatedUser.realName.length >= 20
                    ? `${lastActivatedUser.realName.substring(0, 20)}...`
                    : lastActivatedUser.realName}
                </span>
                <span className="dashboard-card-body-user-data-tenant">
                  {lastActivatedUser.tenants.map((tenant, index) => (
                    <React.Fragment key={index}>
                      {tenant.length >= 20
                        ? `${tenant.substring(0, 20)}...`
                        : tenant}
                      {index < lastActivatedUser.tenants.length - 1 ? (
                        <br />
                      ) : (
                        ""
                      )}
                    </React.Fragment>
                  ))}
                </span>
              </div>
            </div>
            <div className="dashboard-card-body-user-part2">
              {lastActivatedUser.activationDate}
            </div>
          </Card.Body>
          <Card.Footer className="dashboard-card-footer-user">
            {translator("Dashboard-LastActivatedUser-Title")}
          </Card.Footer>
        </>
      )}
    </>
  );
};

export default LastActivatedUser;
